import React, { useEffect, useState } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import axios from "axios";
import queryString from 'query-string';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ProfileMain from "./profile/ProfileMain";
import DefaultLoader from "../components/loader/DefaultLoader";
import RecentGame from "./profile/RecentGameMain";
import NextSeriesMain from "./profile/NextSeriesMain";
import TrackmanChartMain from "./record/TrackmanChartMain";
import SprayChartMain from "./record/SprayChartMain";
import DamageChartMain from "./record/DamageChartMain";
import PitchLocationMain from "./record/PitchLocationMain";
import RecordTableMain from "./record/RecordTableMain";
import SeriesMain from './series/SeriesMain';
import {useCookies} from 'react-cookie';
import Header from "../components/header/Header";
import SearchBar from "../components/searchBar/SearchBar";
import MovingChartMain from "./record/MovingChartMain";
import { intervalLogging, stopLogging} from '../components/common/Logger';
import ProfileImage from "./profile/ProfileImage";

function BatterPage() {
    const [cookies] = useCookies(['hiball_token']);
    const navigate = useNavigate();
    const location = useLocation();
    let [profile, setProfile] = useState({
        playerId: null, teamId: null, type: null, battingHand: null,
        birthdate: null
    });

    const { playerId } = useParams();

    useEffect(() => {
        const season = new Date().getFullYear();
        let playerObj = {
            playerType: 'batter',
            playerId
        }
        stopLogging();
        intervalLogging(location.pathname, cookies['hiball_token'], playerObj);
        axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'digestRecord', recordName: 'selectProfile',
                batterIds: playerId,
                seasons: season,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        }).then((result) => {
            if(result.data.result.length < 1){
                navigate('/');
            } else {
                setProfile({
                    playerId: playerId,
                    teamId: result['data']['result'][0]['batter']['batterTeamId'],
                    type: 'batter',
                    battingHand: result['data']['result'][0]['batter']['battingHand'],
                    birthdate: result['data']['result'][0]['batter']['birthdate']
                });
            }
        });
    }, [])

    const style={
        height: '450px',
        display: 'flex',
        flexDirection: 'column'
    }

    return (
        <>
        <Header title={'타자'}/>
        <Container fluid="xl" className="container">
            <Row>
                <SearchBar/>
            </Row>
            <Row>
                <Col md={3} className="digestDivBox" id="playerImage">
                    {
                        profile['teamId'] ? 
                        <ProfileImage profile={profile}/> :
                        <div style={{...style, ...{height:'390px'}}}>
                            <DefaultLoader/>
                        </div>
                    }
                </Col>
                <Col className="digestDivBox" id="playerProfile">
                    {
                        profile['teamId'] ? 
                        <ProfileMain profile={profile}/> :
                        <div style={{...style, ...{height:'390px'}}}>
                            <DefaultLoader/>
                        </div>
                    }
                </Col>
            </Row>
            <Row>
                <Col md={3} id="last10games" className="digestDivBox">
                    {
                        profile['teamId'] ? 
                        <RecentGame profile={profile}/> :
                        <div style={{...style, ...{height:'390px'}}}>
                            <DefaultLoader/>
                        </div>
                    }
                </Col>
                <Col id="chartZone2" className="digestDivBox" style={{position:'relative'}}>
                    <div style={style}>
                        {
                            profile['teamId'] ?
                            <SprayChartMain profile={profile} /> :
                            <DefaultLoader/>
                        }
                    </div>
                </Col>
                {/* <Col id="gameSchedule" className="digestDivBox">
                    {
                        profile['teamId'] ? 
                        <NextSeriesMain profile={profile}/> :
                        <div style={{...style, ...{height:'390px'}}}>
                            <DefaultLoader/>
                        </div>
                    }
                </Col> */}
            </Row>
            <Row>
                {
                    profile['teamId'] ? 
                    <SeriesMain profile={profile}/> :
                    <Col md={12} >
                        <div style={{height: '300px'}}>
                            <DefaultLoader/>
                        </div>
                    </Col>
                }
            </Row>
            {/* <Row>
                <Col id="chartZone1" className="digestDivBox" style={{position:'relative'}}>
                    <div style={style}>
                        {
                            profile['teamId'] ? 
                            <TrackmanChartMain profile={profile} /> :
                            <DefaultLoader/>
                        }
                    </div>
                </Col>
                <Col id="chartZone2" className="digestDivBox" style={{position:'relative'}}>
                    <div style={style}>
                        {
                            profile['teamId'] ?
                            <SprayChartMain profile={profile} /> :
                            <DefaultLoader/>
                        }
                    </div>
                </Col>
            </Row> */}
            {/* <Row>
                <Col id="movingChartZone" className="digestDivBox" style={{position:'relative'}}>
                    {
                        profile['teamId'] ?
                        <MovingChartMain profile={profile} /> :
                        <DefaultLoader/>
                    }
                </Col>
            </Row>
            <Row>
            {
                profile['teamId'] ?
                <DamageChartMain profile={profile} /> :
                <Col md={12}>
                    <div style={{height: '100px'}}>
                        <DefaultLoader/>
                    </div>
                </Col>
            }
            {
                profile['teamId'] ?
                <PitchLocationMain profile={profile} /> :
                <Col md={12}>
                    <div style={{height: '100px'}}>
                        <DefaultLoader/>
                    </div>
                </Col>
            }
            </Row>
            <Row>
                <div id="tableContainer">
                {
                    profile['teamId'] ?
                    <RecordTableMain profile={profile}/> :
                    <div style={{height: '200px'}}>
                        <DefaultLoader/>
                    </div>
                }
                </div>
            </Row> */}
        </Container>
        </>
    )
}

export default BatterPage;